import React, {useState} from "react";
import { Grid } from '@material-ui/core';
import { Select, Button, Tooltip, Icon } from 'antd';
import TextEvents from 'app/components/TextEvents';
import { styles, useStyles } from '../HistoryCompaignStyle';
import { useDispatch, useSelector } from 'react-redux';
import * as HistoryActions from 'app/actions/HistoryCampaignActions';

const FilterFormScreen = (props) => {  
    const classes = useStyles();
    const [collapse,setCollapse] = useState(true);
   
    const [disabledH, setDisbaledH] = useState(true);
    const dispatch = useDispatch();
    const trag = React.createRef();
    const {
        ListTraining,
        ListSpecialty,
        ListProgramCom,
        ListProcedureMaterial,
        filter,
        pagination
    } = useSelector(state => state.HistoryCampaignReducer)
    const { idSubdirection } = useSelector((state) => state.Auth.employeeById);

    const optionTrainingFilter = ListTraining.map((item) =>
        <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>
    );

    const optionSpecialtyFilter = ListSpecialty.map((item) =>
        <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>
    );

    const optionProgramFilter = ListProgramCom.map((item) =>
        <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>
    );

    const optionProcedureFilter = ListProcedureMaterial.map((item) =>
        <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>
    );
    const onSelectTraining = (training) => {
        props.setTrainingF(training)
        const listIdTraining = training.join(',');
        dispatch(HistoryActions.getSpecialtyOrSystemHC({SubDirectionOrigin: idSubdirection, ListTraining: listIdTraining}))
        dispatch(HistoryActions.getCommunicationProgramHC({SubDirectionOrigin: idSubdirection, ListTraining: listIdTraining}))
        dispatch(HistoryActions.getProcedureMaterialHC({SubDirectionOrigin: idSubdirection, ListTraining: listIdTraining}))
        
        props.setSpecialtyF(props.specialtyF.filter(x => ListSpecialty.filter(y => training.includes(y.id)).map(z => z.key).includes(x)))
        props.setCommunicationF(props.communicationF.filter(x => ListProgramCom.filter(y => training.includes(y.id)).map(z => z.key).includes(x)))
        props.setProcedureF(props.procedureF.filter(x => ListProcedureMaterial.filter(y => training.includes(y.id)).map(z => z.key).includes(x)))

        if(training.length === 0){
            
              trag.current.focus();
            
            dispatch(HistoryActions.clearHistoryCampaign())

        }
        setDisbaledH(training.length >= 1 ? false : true);
    }
    const onSelectSpecialty = (specialty) => {
         props.setSpecialtyF(specialty);
    }

    const onSelectCommunication = (communication) =>{
        props.setCommunicationF(communication);
    }

    const onSelectProcedure = (procedure) => {
        props.setProcedureF(procedure);
    }
    const data = {
            SubDirectionOrigin: idSubdirection,
            ListTraining: props.trainingF.join(','),
            ListSpecialty: props.specialtyF.join(','),
            ListProgramCom: props.communicationF.join(','),
            ListProcedureMaterial: props.procedureF.join(','),
            offset: 0,
            limit: pagination.pageSize,
            sortColumn: pagination.column,
            sortDir: pagination.order,
    }
    const search= () => {
        dispatch(HistoryActions.fetchHistoryCampaign(data));
    }
    const exportXls = () => {
        dispatch(HistoryActions.exportXls(data))
    }

    return (
        <div>
            <div hidden={collapse}>
                <Grid container direction="row" spacing={2}>
                    <Grid item xs={12} >

                        <TextEvents
                            text='Tipo de Capacitación:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            // loading={isLoadingNames}
                            placeholder="Selecionar Tipo de Capacitación"
                            showSearch
                            ref={trag}
                            value={props.trainingF}
                            onChange={onSelectTraining}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            mode="multiple"
                        >
                            {optionTrainingFilter}
                        </Select>
                    </Grid>
                </Grid>
                <Grid container direction="row" spacing={2}>
                    <Grid item xs={4} >
                        <TextEvents
                            text='Sistema/Especialidad:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            // loading={isLoadingNames}
                            //ref={refDis}
                            placeholder="Selecionar Sistema o Especialidad"
                            showSearch
                            value={props.specialtyF}
                            onChange={onSelectSpecialty}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            disabled={disabledH}
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            mode="multiple"
                        >
                            {optionSpecialtyFilter}
                        </Select>

                    </Grid>

                    <Grid item xs={4} >

                        <TextEvents
                            text='Programa de Comunicación:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            // loading={isLoadingNames}
                           // ref={refDis}
                            placeholder="Selecionar Programa de Comunicación"
                            showSearch
                            disabled={disabledH}
                            value={props.communicationF}
                            onChange={onSelectCommunication}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            mode="multiple"
                        >
                            {optionProgramFilter}
                        </Select>

                    </Grid>

                    <Grid item xs={4} >

                        <TextEvents
                            text='Procedimiento/Material de Capacitación:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                         <Select
                            // loading={isLoadingNames}
                           // ref={refDis}
                            placeholder="Selecionar Sistema o Especialidad"
                            showSearch
                            value={props.procedureF}
                            onChange={onSelectProcedure}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            disabled={disabledH}
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            mode="multiple"
                        >
                            {optionProcedureFilter}
                        </Select>

                    </Grid>

                </Grid>
            </div>
            <div className={classes.container} style={styles.baseVerticalMargin}>
                {
                    collapse ?
                        <Tooltip title={"Mostrar filtro"}>
                            <Button
                                className={classes.button}
                                variant="contained"
                                type="link"
                                onClick={() => setCollapse(false)}
                            >
                                <Icon type="down" />
                            </Button>
                        </Tooltip> :
                        <Tooltip title={"Ocultar filtro"}>
                            <Button
                                className={classes.button}
                                variant="contained"
                                type="link"
                                onClick={() => setCollapse(true)}
                            >
                                <Icon type="up" />
                            </Button>
                        </Tooltip>
                }
                <Button
                    className={classes.button}
                    variant="contained"
                    type="primary"
                    disabled={disabledH}
                    onClick={() => search()}
                >
                    Buscar
                </Button>
                <Button
                    className={classes.button}
                    //loading={isLoadExport}
                    variant="contained"
                    type="primary"
                    disabled={disabledH}
                    onClick={() => exportXls()}
                >
                    Exportar
                </Button>
            </div>
        </div>
    )
}

export default FilterFormScreen;